import { render, staticRenderFns } from "./Alter.vue?vue&type=template&id=37d8ac14&"
import script from "./Alter.vue?vue&type=script&lang=js&"
export * from "./Alter.vue?vue&type=script&lang=js&"
import style0 from "./Alter.vue?vue&type=style&index=0&id=37d8ac14&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37d8ac14')) {
      api.createRecord('37d8ac14', component.options)
    } else {
      api.reload('37d8ac14', component.options)
    }
    module.hot.accept("./Alter.vue?vue&type=template&id=37d8ac14&", function () {
      api.rerender('37d8ac14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Gravame/Alter.vue"
export default component.exports